export default "__VITE_ASSET__Ctxa4BSC__"